'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useState, useEffect } from 'react'

const navigationItems = [
  {
    key: 'apm',
    href: '/application-performance-monitoring',
    label: 'APM',
    whitespaceNowrap: false,
  },
  {
    key: 'tracing',
    href: '/distributed-tracing',
    label: 'Distributed Tracing',
    whitespaceNowrap: true,
  },
  {
    key: 'logs',
    href: '/log-management',
    label: 'Log Management',
    whitespaceNowrap: true,
  },
  {
    key: 'metrics',
    href: '/metrics-and-dashboards',
    label: 'Metrics & Dashboards',
    whitespaceNowrap: true,
  },
  {
    key: 'exceptions',
    href: '/exceptions-monitoring',
    label: 'Exceptions',
    whitespaceNowrap: false,
  },
  {
    key: 'alerts',
    href: '/alerts-management',
    label: 'Alerts',
    whitespaceNowrap: false,
  },
]

export default function ProductNav() {
  const pathname = usePathname()
  const [activeTab, setActiveTab] = useState('')

  useEffect(() => {
    const activeItem = navigationItems.find((item) => pathname.startsWith(item.href))
    if (activeItem) {
      setActiveTab(activeItem.key)
    }
  }, [pathname])

  return (
    <div className="fixed left-0 right-0 top-[56px] z-10">
      <header className="header-bg mx-auto box-border h-[56px] w-full border-b border-[var(--l1-border)] text-[var(--l1-foreground)] backdrop-blur-[20px]">
        <div className="mx-auto h-fit max-w-8xl overflow-x-auto xl:max-[1728px]:max-w-[80dvw]">
          <nav
            className="mb-0 flex h-[55px] gap-3 pl-0 text-center text-sm font-medium text-[var(--l2-foreground)] sm:gap-6"
            aria-label="Product Navigation"
          >
            {navigationItems.map((item) => (
              <Link
                key={item.key}
                href={item.href}
                className={`inline-flex h-full shrink-0 items-center whitespace-nowrap rounded-t-lg px-1 py-1.5 pb-3.5 ${
                  activeTab === item.key
                    ? 'border-b-2 border-[var(--accent-primary)] text-[var(--l1-foreground)]'
                    : ''
                }`}
                prefetch={false}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>
    </div>
  )
}
